import { makeStyles } from "@material-ui/core/styles";
import {
  grey300,
  primary,
} from "../../../../../infrastructure/theme/customColors";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "40vw",
  },
  buttonRow: {
    "& button": {
      margin: `0 ${theme.spacing(1)}px`,
    },
    paddingTop: theme.spacing(1),
  },
  divider: {
    height: 1,
    backgroundColor: grey300,
    margin: `${theme.spacing(1)}px 0`,
  },
  resultText: {
    color: primary,
  },
  row: {
    padding: theme.spacing(1),
  },
}));
export default useStyles;
